import React, { useState, useEffect, useContext } from "react";
import { Input, SelectCountries } from "../Layout/Forms/Form";
import { Link, useNavigate } from "react-router-dom";

import "./SignUp.css";
import SignupRequests from "./SignupRequests";
import { AuthContext } from "../../Context/AppContext";
import ReCAPTCHA from "react-google-recaptcha";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../../components/Loading";

// Version: 1.1 - Premium Design Update
const SignUp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { setUserInfo } = useContext(AuthContext);
  let captcha;
  const setCaptchaRef = (ref) => {
    if (ref) {
      return (captcha = ref);
    }
  };
  const [state, setState] = useState({
    form: {
      firstname: "",
      lastname: "",
      phone_country: "",
      phone_number: "",
      email: "",
      nipc: "",
      name_company: "",
      password: "",
      password_repeat: "",
      account_type: "",
      recaptcha: "",
    },
    errors: [],
  });

  const [isVerified, setIsVerified] = useState(false);

  const handleRecaptchaChange = (token) => {
    setIsVerified(true);
    handleChangeInputs({
      target: {
        name: "recaptcha",
        value: token,
      },
    });
  };

  const [countryList, setCountryList] = useState([]);
  const handleChangeInputs = (e) => {
    if (!isLoading) {
      setState({
        ...state,
        form: {
          ...state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  const seriaizeCountryList = () => {
    if (countryList && countryList.length > 0)
      return countryList.map((item) => {
        return {
          label: item.name,
          value: item.phone_country,
          icon: item.icon,
        };
      });
  };

  useEffect(async () => {
    document.title = "Sign up | Nightspot";
    setIsLoading(true);
    let info = await SignupRequests.getInfoSignup();
    if (info && info.status) {
      setCountryList(info.data);
      setState({
        ...state,
        form: {
          ...state.form,
          phone_country: "+351",
        },
      });
    }
    setIsLoading(false);
  }, []);

  const handlerSubmitFormSignup = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    if (state.form.password !== state.form.password_repeat) {
      setState({
        ...state,
        errors: {
          password_repeat: ["As passwords não correspondem"],
          password: [""],
        },
      });
      setIsLoading(false);
      return;
    }

    if (isVerified && state.form.recaptcha) {
      let response = await SignupRequests.signUp(state.form);
      if (response && response.status) {
        setUserInfo({
          firstName: response.data.firstname,
          lastName: response.data.lastname,
        });
        localStorage.setItem("token-api", response.access_token);

        toast.success(
          "O seu registo foi efectuado com sucesso. Ative a sua conta com o link que enviámos para o seu e-mail",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          },
        );
        navigate("/login?ref=signup");
      } else {
        setState({
          ...state,
          errors: response.errors,
        });
      }
      captcha.reset();
    } else {
      toast.error("Verifique o reCAPTCHA antes de submeter o formulário.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }

    setIsLoading(false);
  };

  return isLoading ? (
    <Loading />
  ) : (
    <div className="signup-container">
      <div className="signup-background"></div>
      <div className="signup-content">
        <div className="signup-info-column">
          <div className="signup-header">
            <h1>Nightspot</h1>
            <p className="hero-text">Estás prestes a revolucionar os teus eventos.</p>
            <p className="sub-hero-text">Bem-vindo à plataforma que simplifica a gestão de eventos.</p>
          </div>
        </div>
        <div className="signup-form-column">
          <div className="signup-form-wrapper">
            <form onSubmit={handlerSubmitFormSignup}>
              <div className="row">
                <div className="col-md-6 mb-3 mb-md-0">
                  <Input
                    label="Nome"
                    name="firstname"
                    value={state.form.firstname}
                    onChange={handleChangeInputs}
                    onPaste={(e) => {
                      e.preventDefault();
                      handleChangeInputs({
                        target: {
                          name: e.target.name,
                          value: e.clipboardData.getData("Text"),
                        },
                      });
                    }}
                    errors={state.errors}
                    placeholder="Escreva o seu nome"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label="Apelido"
                    name="lastname"
                    value={state.form.lastname}
                    onChange={handleChangeInputs}
                    onPaste={(e) => {
                      e.preventDefault();
                      handleChangeInputs({
                        target: {
                          name: e.target.name,
                          value: e.clipboardData.getData("Text"),
                        },
                      });
                    }}
                    errors={state.errors}
                    placeholder="Escreva o seu apelido"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-sm-6 mb-3 mb-sm-0">
                  <div className="row">
                    <div className="col-4">
                      <SelectCountries
                        label="DDI"
                        name="phone_country"
                        value={state.form.phone_country}
                        onChange={handleChangeInputs}
                        options={seriaizeCountryList()}
                        errors={state.errors}
                      />
                    </div>
                    <div className="col-8">
                      <Input
                        label="Telemóvel"
                        name="phone_number"
                        value={state.form.phone_number}
                        onChange={handleChangeInputs}
                        onPaste={(e) => {
                          e.preventDefault();
                          handleChangeInputs({
                            target: {
                              name: e.target.name,
                              value: e.clipboardData.getData("Text"),
                            },
                          });
                        }}
                        errors={state.errors}
                        placeholder="Número"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-6">
                  <Input
                    label="Email"
                    name="email"
                    value={state.form.email}
                    onPaste={(e) => {
                      e.preventDefault();
                      handleChangeInputs({
                        target: {
                          name: e.target.name,
                          value: e.clipboardData.getData("Text"),
                        },
                      });
                    }}
                    onChange={handleChangeInputs}
                    errors={state.errors}
                    placeholder="o-teu-email@exemplo.com"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3 mb-md-0">
                  <Input
                    label="Empresa"
                    name="name_company"
                    value={state.form.name_company}
                    onChange={handleChangeInputs}
                    onPaste={(e) => {
                      e.preventDefault();
                      handleChangeInputs({
                        target: {
                          name: e.target.name,
                          value: e.clipboardData.getData("Text"),
                        },
                      });
                    }}
                    errors={state.errors}
                    placeholder="Nome"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label="NIF"
                    name="nipc"
                    value={state.form.nipc}
                    onChange={handleChangeInputs}
                    onPaste={(e) => {
                      e.preventDefault();
                      handleChangeInputs({
                        target: {
                          name: e.target.name,
                          value: e.clipboardData.getData("Text"),
                        },
                      });
                    }}
                    errors={state.errors}
                    placeholder="Identificação Fiscal"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3 mb-md-0">
                  <Input
                    label="Password"
                    name="password"
                    type="password"
                    value={state.form.password}
                    onChange={handleChangeInputs}
                    onPaste={(e) => {
                      e.preventDefault();
                      handleChangeInputs({
                        target: {
                          name: e.target.name,
                          value: e.clipboardData.getData("Text"),
                        },
                      });
                    }}
                    errors={state.errors}
                    placeholder="Password"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label="Confirmar"
                    name="password_repeat"
                    type="password"
                    value={state.form.password_repeat}
                    onChange={handleChangeInputs}
                    onPaste={(e) => {
                      e.preventDefault();
                      handleChangeInputs({
                        target: {
                          name: e.target.name,
                          value: e.clipboardData.getData("Text"),
                        },
                      });
                    }}
                    errors={state.errors}
                    placeholder="Repetir password"
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-12 captcha-container">
                  <ReCAPTCHA
                    ref={(r) => setCaptchaRef(r)}
                    theme="dark"
                    sitekey="6LeVVUYlAAAAAE8OMUoEmZH4DD_7ukaaDB-S6E9H"
                    onChange={handleRecaptchaChange}
                  />
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-12 d-grid mx-auto text-center">
                  <button type="submit" className="btn-registar">
                    REGISTAR
                  </button>
                </div>
              </div>
            </form>
            <div className="login-link-section">
              <div className="row">
                <div className="col-12 d-grid mx-auto text-center">
                  <Link className="btn-login-outline" to="/login">
                    LOGIN
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
